<!-- Disclaimer -->
<mc-window #disclaimerWindow id="disclaimerWindow" modal="true" title="Login Required" width="500" closable="false">
    <div slot=content>
        <div class="panel trailer-half">
            <span *ngIf="pdauthUserId && pdauthToken"> You are logging in as: {{pdauthUserId}}</span>
            <span *ngIf="pdauthUserId && userPermissions && userPermissions.length ==0 "> You do not have permissions to use this application.</span>
            <br />
            <span>This application is for PennDOT internal use only. Please login with appropriate PennDOT Transportation group user credentials to access site.</span>
        </div>
        <button class="btn btn-small" (click)="logInOrOut($event)" style="float: left">Log In</button>
    </div>
</mc-window>

<!-- Map Catalog -->
<mc-window #mapCatalogWindow modal="true" title="Map Catalog" width="800" height="700">
    <mc-map-catalog #mapCatalog slot="content" show-system-maps="true" show-only-application-user-maps="true" show-user-maps="true" [loggedIn]="loggedIn" (shouldLogIn)="logInOrOut($event)" (ondone)="closeMapCatalog($event)" (onmapopened)="mapOpened($event)"></mc-map-catalog>
</mc-window>

<!-- Map Merge -->
<mc-window #mapMergeWindow modal="true" min-height="200" width="500">
    <mc-merge-map #mapMerge slot="content" include-map-filter="true"></mc-merge-map>
</mc-window>

<!-- Layer Catalog -->
<mc-window #layerCatalogWindow modal="true" title="Layer Catalog"
           is-resizable="true" is-draggable="true" width="760"
           (openChange)="layerCatalogWindowOpenChange($event)">
    <mc-layer-catalog #layerCatalog slot="content" filter-layers-before-add="true" (layersAdded)="layersAddedFromCatalog($event)"></mc-layer-catalog>
</mc-window>

<!-- Share Layer -->
<mc-window #shareLayerWindow id="shareLayerWindow" title="Share Layer" is-draggable="true" is-resizable="true" [width]="800" [maxHeight]="800">
    <mc-share-layer #shareLayer slot="content"></mc-share-layer>
</mc-window>

<!-- Unshare Layer -->
<mc-window #unshareLayerWindow id="unshareLayerWindow" title="Unshare Layer" is-draggable="true" is-resizable="true" [width]="800" [maxHeight]="800">
    <mc-unshare-layer #unshareLayer slot="content"></mc-unshare-layer>
</mc-window>

<!-- Measure Tool -->
<mc-window #measureToolsWindow title="Measure" width="600" top="65" left="175" is-draggable="true" (openChange)="onWindowOpenChange($event)">
    <div slot="content">
        <mc-tabs #tabs [tabs]='[{"name":"Distance", "active":true},{"name":"Area"},{"name":"Coordinates"}]' (tabChanged)="onTabChanged($event)">
            <div slot="tab_1">
                <mc-distance #distance></mc-distance>
            </div>
            <div slot="tab_2">
                <mc-area #area></mc-area>
            </div>
            <div slot="tab_3">
                <mc-coordinates #coordinates current-mode="capture"></mc-coordinates>
            </div>
        </mc-tabs>
    </div>
</mc-window>

<!-- Routing Tool -->
<mc-window #routingWindow title="Routing" width="300" top="65" left="175" is-draggable="true">
    <mc-routing #routing slot="content"></mc-routing>
</mc-window>

<!-- Bookmarks -->
<mc-window #bookmarksWindow is-resizable="false" title="Bookmarks" is-draggable="true" height="583" width="500">
    <mc-bookmark #bookmarks slot="content" app-name="Maintenance_IQ"></mc-bookmark>
</mc-window>

<!-- User Settings -->
<mc-window #userSettingsWindow is-resizable="true" title="User Settings" is-draggable="true" height="583" width="500">
    <mc-user-settings #userSettings slot="content" app-name="Maintenance_IQ"></mc-user-settings>
</mc-window>

<!-- Video Log -->
<mc-window #videoLogWindow title="Video Log" top="50" left="200" width="650" height="780" is-draggable="true" is-resizable="true" is-maximizable="true" style="position:relative; overflow-y: scroll;">
    <div slot="content" style="margin: -16px;">
        <div style="position: relative; height: 60%; margin-bottom: 30px;">
            <mc-video-log-viewer #videoLog buffer="1100" [markerSymbol]="markerSymbol" zoom-on-position-change="first"></mc-video-log-viewer>
            <mc-video-log-controller #videoLogController allow-zoom-type-change="true" hide-download-btn="false"></mc-video-log-controller>
        </div>
        <mc-video-log-info></mc-video-log-info>
    </div>
</mc-window>

<!-- Street View -->
<mc-window #streetViewWindow title="Street View" width="600" height="500" is-draggable="true" is-resizable="true">
    <mc-street-view #streetView slot="content" lat="40.263001" long="-76.884089">
        <div slot="widget-group" class="widget-group">
            <mc-rms-select slot="rms-select" #rmsSelect></mc-rms-select>
            <mc-lat-long-select slot="lat-long-select" #latLongSelect></mc-lat-long-select>
        </div>
    </mc-street-view>
</mc-window>

<!-- PETL -->
<mc-window #petlWindow title="PETL" width="95%" height="95%" modal="true">
    <mc-petl #petl slot="content" zoom-to-layer="true" enable-map-file-drop="true" (onfiledrop)="openPetl($event)" (onpetlclose)="closePetl($event)"></mc-petl>
</mc-window>

<!-- Callout Tool -->
<mc-window #calloutToolWindow is-resizable="true" title="Callout Box" is-draggable="true" height="583" width="500">
    <mc-callout #calloutTool slot="content"></mc-callout>
</mc-window>

<!-- ISLE -->
<mc-window #isleWindow title="ISLE" is-resizable="true" is-draggable="true" height="500" width="720">
    <button slot="actions" (click)="goToIsle($event)">Go to ISLE</button>
    <mc-isle #isle slot="content" tolerance="1100"></mc-isle>
</mc-window>

<!-- IROW -->
<mc-window #irowWindow title="IROW" is-resizable="true" is-draggable="true" height="500" width="720">
    <button slot="actions" (click)="goToIrow($event)">Go to IROW</button>
    <mc-irow #irow slot="content" tolerance="1100"></mc-irow>
</mc-window>

<!-- About -->
<mc-window #aboutWindow modal="true" title="About" [width]="650" [height]="650">
    <div slot="content">
        <h3>PennDOT Maintenance IQ</h3>
        <p><a href="static/whatsNew.html" target="_blank">Version 2.0</a></p>
        <p>
            PennDOT's Bureau of Maintenance and Operations (BOMO)
        </p>
        <p>
            BOMO partnered with the Bureau of Planning and Research, Innovations Office, District and County staff to develop a GIS application, Maintenance-IQ, to improve the planning and scheduling of maintenance activities. Maintenance-IQ helps PennDOT eliminate out-of sequence rework (i.e., prep-type activities performed soon after a surface improvement), support getting selected maintenance activities "on-cycle" (in turn, decreasing on-demand maintenance needs and efforts), and reduce mobilization and travel time costs. GIS mapping is a perfect fit for maintenance planning because it provides the ability to easily integrate, analyze, and visualize disparate data from multiple sources.
        </p>
        <p>
            Maintenance-IQ serves as the GIS visualization portal for planned and completed maintenance activities across the state. Maintenance-IQ provides an interface for showing sets of map data which can be exported and queried for attribute data. This application gives end users the ability to query various datasets of GIS data and visualize them on a map and share them between other users.
        </p>
        <p>
            Maintenance-IQ was developed in early 2015 with a focus on data sharing and analysis in a streamlined, user-friendly UI.
        </p>
        <p>
            Maintenance-IQ is based on Esri's ArcGIS Server, Oracle, and Angular.
        </p>
    </div>
</mc-window>

<!-- Contact -->
<mc-window #contactWindow modal="true" title="Contact Us" is-resizable="false" [width]="650" [height]="400">
    <div slot="content">
        <p>
            Please feel free to contact a representative with any questions, comments or issues at the following email
            address:
        </p>
        <select class="select" [(ngModel)]="selectedDistrictId" name="districtDropdown">
            <option value="0">Select an Organization...</option>
            <option *ngFor="let contact of contactList" [ngValue]="contact.id">
                {{ contact.district }}
            </option>
        </select>
        <br />
        <table *ngIf="selectedDistrictId > 0">
            <tr *ngFor="let contact of contactList[selectedDistrictId-1].contactPersons">
                <td>{{contact.firstName}} {{contact.lastName}} {{contact.position?'('+contact.position+')':''}} - <a (click)="closeContactWindow()" href="mailto:{{contact.email}}?cc={{contact.ccList}}">{{contact.email}}</a></td>
            </tr>
        </table>
    </div>
</mc-window>

<!-- Draw Tools -->
<mc-window #drawToolWindow id="draw-tool-window" title="Draw Tool" is-draggable="true" is-resizable="true" [top]="drawToolTop"
           [width]="drawToolWidth" [maxHeight]="maxHeight">
    <miq-draw-tool #drawTool id="draw-tool" slot="content"></miq-draw-tool>
</mc-window>

<!-- Reset -->
<mc-window #resetMapWindow id='reset-map-window' title="Reset Map" modal="true">
    <div slot="content">
        <p>Are you sure you would like to reset your map?</p>
        <div class="reset-button-group flex-display flex-row">
            <button class="btn reset-button" (click)="resetMap()">Yes</button>
            <button class="btn reset-button" (click)="closeResetMap()">No</button>
        </div>
    </div>
</mc-window>

<!-- System Messages -->
<mc-window #systemMessagesWindow [windowTitle]="'System Messages (' + unreadMessages + ')'" width="700" modal="true">
    <mc-system-messages #systemMessages slot="content"></mc-system-messages>
</mc-window>

<mc-auth #auth [attr.auth-url]="pdauthURL" app-name="Maintenance_IQ" show-user="false" prefix="Logged in as " auto-login="true"></mc-auth>

<!-- Header -->
<header class="block-display width-wrap">
    <nav class="flex-display width-wrap">
        <a class="logo clickable flex-shrink" (click)="openResetMap()">
            <img src="assets/penndot_logo_glow.png"
                 alt="PennDOT Maintenance IQ" />
            Maintenance-IQ<span *ngIf="titleAddition" class="env">{{ titleAddition }}</span>
        </a>
        <div class="navRight flex-grow flex-display">
            <button class="btn icon-ui-search" (click)="toggleSearchTips($event)"></button>
            <miq-search-tips #searchTips></miq-search-tips>
            <mc-search id="search" #search slot="top-right" [maxResults]="200" add-selection-to-map="true" (onresultselected)="searchResultSelected($event)"></mc-search>
            <button (click)="openMapCatalog($event)" class="btn">Maps</button>
            <button (click)="openLayerCatalog($event)" class="btn">Layers</button>
            <div class="dropdown js-dropdown">
                <button class="btn dropdown-btn js-dropdown-toggle" tabindex="0" aria-haspopup="true"
                        aria-expanded="false">
                    Tools <span class="icon-ui-down-arrow icon-ui-flush"></span>
                </button>
                <nav class="dropdown-menu dropdown-right" role="menu">
                    <button (click)="openDrawTool($event)" class="dropdown-link btn" role="menuitem">
                        <span class="icon-ui-edit"></span> Draw Tool
                    </button>
                    <button (click)="openMeasureTools($event)" class="dropdown-link btn" role="menuitem">
                        <span class="icon-ui-line-chart"></span> Measurement
                    </button>
                    <button (click)="openRouting($event)" class="dropdown-link btn" role="menuitem">
                        <span class="icon-ui-navigation"></span> Routing
                    </button>
                    <button (click)="openStreetView($event)" class="dropdown-link btn" role="menuitem">
                        <span class="icon-ui-map-pin"></span> Street View
                    </button>
                    <button (click)="openVideoLog($event)" class="dropdown-link btn" role="menuitem">
                        <span class="icon-ui-play"></span> Video Log
                    </button>
                    <button (click)="showOverview = !showOverview" class="dropdown-link btn" role="menuitem">
                        <span class="icon-ui-maps"></span> Overview
                    </button>
                    <button (click)="openCalloutTool($event)" class="dropdown-link btn" role="menuitem">
                        <span class="icon-ui-chat"></span> Callout Box Tool
                    </button>
                    <button (click)="openPetl($event)" class="dropdown-link btn" role="menuitem">
                        <span class="icon-ui-table"></span> PETL
                    </button>
                    <button (click)="openIsle($event)" class="dropdown-link btn" role="menuitem" [class.rms]="rms">
                        <span class="icon-ui-layers"></span> Isle
                    </button>
                    <button (click)="openIrow($event)" class="dropdown-link btn" role="menuitem" [class.rms]="rms">
                        <span class="icon-ui-layers"></span> IROW
                    </button>
                    <button (click)="openTIRe($event)" class="dropdown-link btn" role="menuitem" [class.rms]="rms">
                        <span class="icon-ui-link-external"></span> TIRe {{rmsSnippet}}
                    </button>
                </nav>
            </div>

            <!-- System Messages -->
            <button (click)="openSystemMessages($event)" class="btn btn-white" title="System Messages"><span class="icon-ui-announcement"></span> {{ unreadMessages }}</button>

            <!-- User Info -->
            <div class="dropdown js-dropdown">
                <button class="btn dropdown-btn js-dropdown-toggle" tabindex="0" aria-haspopup="true"
                        aria-expanded="false">
                    <i class="icon-ui-user" [ngClass]="{'icon-ui-dark-blue': isLoggedIn}"></i> <span class="icon-ui-down-arrow icon-ui-flush"></span>
                </button>
                <nav class="dropdown-menu dropdown-right" role="menu">
                    <span class="dropdown-link btn" [ngStyle]="{'display': isLoggedIn ? '' : 'none'}">
                        <i class="icon-ui-user"></i> Logged in as {{ userName }}
                    </span>
                    <button (click)="logInOrOut($event)" class="dropdown-link btn" role="menuitem">
                        <span class="icon-ui-user" [ngClass]="{'icon-ui-dark-blue': isLoggedIn}"></span>{{ isLoggedIn ? 'Log Out' : 'Log In' }}
                    </button>
                    <button (click)="openUserSettings($event)" class="dropdown-link btn" role="menuitem">
                        <span class="icon-ui-settings2"></span> User Settings
                    </button>
                    <button (click)="openBookmarks($event)" class="dropdown-link btn" role="menuitem">
                        <span class="icon-ui-tag"></span> Bookmarks
                    </button>
                </nav>
            </div>

            <!-- Site Info -->
            <div class="dropdown js-dropdown">
                <button class="btn dropdown-btn js-dropdown-toggle" tabindex="0" aria-haspopup="true"
                        aria-expanded="false">
                    <i class="icon-ui-description"></i> <span class="icon-ui-down-arrow icon-ui-flush"></span>
                </button>
                <nav class="dropdown-menu dropdown-right" role="menu">
                    <button (click)="openAboutWindow()" class="dropdown-link btn" role="menuitem">
                        <i class="icon-ui-description"></i> About
                    </button>
                    <!--<a href="static/webHelp/index.htm" target="_blank" class="dropdown-link btn"
                       role="menuitem"><span class="icon-ui-question"></span>Help</a>-->
                    <a href="https://pagov.sharepoint.com/sites/PD-PAPortal/Highway/M-IQ/SitePages/Home.aspx" target="_blank" class="dropdown-link btn"
                       role="menuitem"><span class="icon-ui-question"></span>M-IQ Resources SharePoint Site</a>
                    <button (click)="openContactWindow()" class="dropdown-link btn" role="menuitem">
                        <i class="icon-ui-contact"></i> Contact Us
                    </button>
                </nav>
            </div>
        </div>
    </nav>
</header>
